import axios from "../../../../utils/axios-private";
import { requestDefaultGenerator } from "../../../../utils/generator";

export const getListCustomer = ({ pageNumber, pageSize, filter }) => {
  if (
    filter.paramsCustomerName !== null &&
    filter.paramsCustomerName !== undefined
  ) {
    filter.nama_pelanggan = `%${filter.paramsCustomerName}%`;
    delete filter.paramsCustomerName;
  } else {
    filter.nama_pelanggan = `%%`;
  }
  const initialRequest = { limit: pageSize, page: pageNumber };
  const request = requestDefaultGenerator(initialRequest, filter);

  return {
    type: "GET_LIST_CUSTOMER",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/pelanggan/list`;
      axios
        .post(url, request, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
